import { gql } from '@apollo/client'

export const GET_COURSE_CONTENT = gql`
  query getCourseContent($courseId: ID!, $id: ID!, $enrollmentId: ID) {
    courseContent(courseId: $courseId, id: $id, enrollmentId: $enrollmentId) {
      lesson {
        id
        title
        courseContentId
        releaseAt
        releaseAfter
        courseClassReleaseOffset
        lockAt
        lockAfter
        createdAt
        description
        activity {
          id
          examQuestionsCount
        }
        media {
          id
          title
          type
          duration
          fileUrl
          fileExt
          text
          hostKey
          host
          organizationUuid
          originUrl
          providerKey
        }
        coverImage {
          cdnFileUrl
        }
        extraMediaReleases {
          mediaId
          releaseAt
          releaseAfter
          lockAt
          lockAfter
        }
        extraMedias {
          id
          title
          type
          duration
          fileExt
          text
          hostKey
          originUrl
          providerKey
          host
          organizationUuid
          createdAt
        }
      }
    }
  }
`
